<template>
  <Menu as="div" class="relative">
    <div class="flex items-center">
      <MenuButton v-if="brandconfig.CURRENCY_OPTION" class="flex gap-1 items-center">
        <div
          :class="
            clsx(
              {
                'text-[10px]': currencySymbol?.length == 2,
                'text-[8px]': currencySymbol?.length && currencySymbol.length >= 3,
              },
              'text-base font-semibold bg-surface rounded-full text-black size-5 leading-5'
            )
          ">
          {{ currencySymbol }}
        </div>
        <span class="whitespace-nowrap hidden lg:block text-sm">{{ currencyName }}</span>
        <ChevronDownIcon class="size-3 flex-none" />
      </MenuButton>
    </div>
    <MenuItems
      class="flex flex-col text-foreground absolute right-0 z-20 mt-2 origin-top-right rounded-md bg-surface shadow-lg ring-1 ring-black/5 overflow-hidden focus:outline-none w-max max-h-80 overflow-y-auto">
      <div class="flex justify-between">
        <h3 class="text-lg font-bold px-4 pb-2 pt-4">{{ $t("Choose your currency") }}</h3>
      </div>
      <div class="py-0.5">
        <MenuItem
          v-for="currency of popularFxRates()"
          :key="currency"
          v-slot="{ active }"
          as="div"
          :disabled="currency[0] === userStore.selectedCurrency"
          @click="selectCurrency(currency[0])">
          <button class="w-full" :class="{ 'bg-neutral-100': active }">
            <div class="px-4 py-2 text-left flex min-w-max justify-between gap-2 items-center">
              <span class="font-medium">{{ currency[3] ? currency[3] : "" }}</span>
              <span class="grow">{{ currency[2] ? currency[2] : currency[0] }}</span>
              <CheckIcon v-if="currency[0] === userStore.selectedCurrency" class="w-5" />
            </div>
          </button>
        </MenuItem>
      </div>
      <button
        v-if="!showAll"
        class="border-t-[#efefef] border-t-2 hover:bg-[#f5f5f5]"
        @click="showAll = showAll !== true">
        <div class="px-4 py-2 text-left flex min-w-max justify-between gap-2 items-center">
          <span class="grow">{{ $t("Show all currencies") }}...</span>
        </div>
      </button>
    </MenuItems>
  </Menu>
  <CurrencyChangeModal :open="showModal" :currency="selectedCurrency" @hide-modal="showModal = false" />
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { CheckIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";
import brandconfig from "@/brandconfig";
import { useUserStore } from "@/store/user";
import CurrencyChangeModal from "./CurrencyChangeModal.vue";
import { computed, ref } from "vue";
import { currencies } from "@xs2event/js-lib";
import clsx from "clsx";
import { DistributorsApi } from "@xs2event/js-lib/api";

const userStore = useUserStore();
const showModal = ref();
const selectedCurrency = ref();
const mostUsedCurrencies = ["EUR", "GBP", "USD"];
const showAll = ref(false);

const popularFxRates = () => {
  if (showAll.value) {
    return userStore.fxRates;
  } else {
    return userStore.fxRates.filter((i) => mostUsedCurrencies.includes(i[0]));
  }
};

const currency = computed(() => currencies.find((c) => c.code == userStore.selectedCurrency));

const currencySymbol = computed(() => currency.value?.symbol);

const currencyName = computed(() => currency.value?.name);

const distributorsApi = new DistributorsApi();
const selectCurrency = async (currency: string) => {
  if (currency !== "EUR") {
    selectedCurrency.value = currency;
    showModal.value = true;
  } else {
    // Currency logging
    await distributorsApi.distributorcurrencychangePost({
      requestedDistributorId: userStore.distributor_id,
      distributorCurrencyChangeRequest: { preferredCurrency: "EUR" },
    });
    showModal.value = false;
    localStorage.fxRate = "EUR";
    setTimeout(() => window.location.reload());
  }
};
</script>
